import { api, setAuthToken, setRefreshToken, URLs } from '@/libs/api'

const getRefreshToken = () => localStorage.getItem('refreshToken')
import type { LoginCredentials, LoginResponse } from '@/libs/interfaces'

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    return await api.post<LoginResponse>(URLs.LOGIN, credentials).then((response) => {
      const { accessToken, refreshToken } = response.data
      setAuthToken(accessToken)
      if (refreshToken) setRefreshToken(refreshToken)
      return response.data
    })
  },
  logout: async (): Promise<void> => {
    await api.post(URLs.LOGOUT, { refreshToken: getRefreshToken() })
  },
}
